import { IOption } from "@erelego/design-system/components/atoms";
import { CaptchadropdownOptions, ICaptchaFieldConfigurationClient, ICaptchaFieldConfigurationServer, TimedropdownOptions } from "./interface";
import {
  IFieldSubmissionMap,
  IFormFieldSubmission,
} from "@common/redux/formSubmission/interface";
import { FieldProps } from "../FormFieldSelector/interfaces";
import { validateRule } from "../FormTextInputField/rules/utils";
import { displayErrorMessage } from "@utils/AlertMessage";

export const captchadropdownOptions: IOption[] = [
  { value: CaptchadropdownOptions.TEXT_BASED, content: "Text based" },
  { value: CaptchadropdownOptions.IMAGE_BASED, content: "image based" }
]

export const timeOptions: IOption[] = [
  { value: TimedropdownOptions.MIN, content: "Mins" },
  { value: TimedropdownOptions.SECONDS, content: "Seconds" }
]

export const generateTextCaptcha = (length: number) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let captcha = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    captcha += characters[randomIndex];
  }
  return captcha;
};

export const imageGallery = [
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvam9iNjc5LTA0NS14LmpwZw.jpg",
    topics: ["dogs", "a dog", "illustrations", "art"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvam9iNjc5LTA3MS14LmpwZw.jpg",
    topics: ["rooster", "chicken", "birds", "illustrations", "art"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcGQyMzUtcGRzdHViYnMwMDEyNi1pbWFnZV8zLmpwZw.jpg",
    topics: ["chicken", "birds", "illustrations", "art"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcGQyMzUtcGRzdHViYnMwMDExNC1pbWFnZTAxXzEuanBn.jpg",
    topics: [
      "horse",
      "a skeleton",
      "skeletons",
      "illustrations",
      "art",
      "equines",
    ],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcGRmbWE0LXBkamVhbmJlcm5hcmQwMDAyOC1pbWFnZS5qcGc.jpg",
    topics: ["cats", "a cat", "illustrations", "art"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcGQyMDQtNDQuanBn.jpg",
    topics: ["donkey", "an ass", "asses", "illustrations", "art", "equines"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIyLTA1L3BkMjEtNTEtMDItcm9iLmpwZw.jpg",
    topics: ["dogs", "a dog", "illustrations", "art"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvam9iNjc5LTAzNS14LmpwZw.jpg",
    topics: ["cats", "a cat", "illustrations", "art"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIyLTA0L2pvYjcxMi0xODQtdi5qcGc.jpg",
    topics: ["pigs", "a pig", "illustrations", "art"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIyLTA1L3BkMjM1LXBkc3R1YmJzMDAxNTctaW1hZ2UwMV80LmpwZw.jpg",
    topics: ["zebra", "painting", "equines"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvam9iNjc4LTI0MC14LmpwZw.jpg",
    topics: ["a tiger", "tigers", "cats", "a cat", "illustration"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIyLTA1L3BkMTAzLW1pc2N0aGVtZXQwMDE3Ny1pbWFnZV8yLmpwZw.jpg",
    topics: ["flowers", "peonies", "painting"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcGQyMDItMTYuanBn.jpg",
    topics: ["a mountain", "mountains", "woodblock print", "print"],
  },
  {
    url: "https://images.rawpixel.com/image_800/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcGQyMzUtcGRzdHViYnMwMDAwNS1pbWFnZV8zLmpwZw.jpg",
    topics: ["skeletons", "a skeleton", "a human", "humans", "illustration"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcGQyMzUtcGRzdHViYnMwMDExNS1pbWFnZV80LmpwZw.jpg",
    topics: ["a dog", "dogs"],
  },
  {
    url: "https://images.rawpixel.com/image_1000/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcGQyMTAtMDA3XzMuanBn.jpg",
    topics: ["birds", "a bird", "print", "pheasants"],
  },
];

export const imageTopics = [
  "skeletons",
  "dogs",
  "pigs",
  "birds",
  "mountains",
  "rodents",
  "humans",
  "equines",
];



export const transformCaptchaFieldConfigClientToServer = (fieldConfigClient: any): ICaptchaFieldConfigurationServer => {
  const { captchadropdownOptions, captchaResetTime, errorMessage, captchabgColor } = fieldConfigClient;

  const fieldConfigServer = {
    captchadropdownOptions: captchadropdownOptions,
    captchaResetTime: captchaResetTime,
    errorMessage: errorMessage,
    captchabgColor: captchabgColor

  };
  return fieldConfigServer;
};

export const transformCaptchaConfigServerToClient = (
  fieldConfigServer: any
): ICaptchaFieldConfigurationClient => {
  const { captchadropdownOptions, captchaResetTime, errorMessage, captchabgColor } = fieldConfigServer;
  const fieldConfigClient = {
    captchadropdownOptions: captchadropdownOptions,
    captchaResetTime: captchaResetTime,
    errorMessage: errorMessage,
    captchabgColor: captchabgColor,
  };
  return fieldConfigClient;
};



export const validateCaptchaFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;

  const submissionValue =
    (fieldSubmissionValue && fieldSubmissionValue?.value) || "";

  if (fieldRules && submissionValue) {
    for (let i = 0; i < fieldRules?.length; i++) {
      const [isValidated, validatationErrorMessage] = validateRule(
        fieldRules[i],
        submissionValue,
        fieldSubmissionMap
      );
      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  }

  if (isRequired) {
    if (!submissionValue) {
      return [false, "Captcha is required"];
    }
  }
  
  if(fieldEditConfig?.fieldValue?.captchadropdownOptions==="TEXTBASED"){
    if (!submissionValue) {
      return [false, "Captcha is required"];
    }
  }
  return [true, ""];
};

export const generateCaptcha = (
  setTextCaptcha: (captcha: string) => void,
  setCaptchaValue: (value: string) => void,
  setErrorVal: (value: boolean) => void,
  exacttime: number,
  Minutes: string
) => {
  setTimeout(() => {
      setTextCaptcha(generateTextCaptcha(6));
      setCaptchaValue('');
      setErrorVal(false);
  }, Minutes === "SECONDS" ? exacttime * 1000 : exacttime * 60000);
};